import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { getAudioTrackInRoom } from "../base/record";
import AudioTrack from "../base/media/components/web/AudioTrack";
const AudioContainer = React.memo(() => {
    const audioTracks = useSelector((state) => getAudioTrackInRoom(state, true), shallowEqual);
    return (audioTracks && audioTracks.map(a => React.createElement(AudioTrack, { key: a.participantId, audioTrack: a })));
});
export default AudioContainer;
